import React from "react";
import { education } from "../data/content";

export default function Education() {
  return (
    <section id="education" className="section-pad border-t border-rule">
      <div className="wrap">
        <header className="reveal mb-8">
          <p className="label">08 / Education</p>
          <h2 className="mt-4 font-display text-[clamp(1.75rem,3vw,2.5rem)] font-semibold tracking-[-0.02em]">
            {education.school}
          </h2>
        </header>

        <div className="reveal grid gap-6 border-t border-rule pt-6 md:grid-cols-3">
          <div>
            <h3 className="label">Credential</h3>
            <p className="mt-2 text-ink">{education.credential}</p>
          </div>
          <div>
            <h3 className="label">Location</h3>
            <p className="mt-2 text-ink">{education.location}</p>
          </div>
          <div>
            <h3 className="label">Period</h3>
            <p className="mt-2 font-mono text-sm text-ink">{education.period}</p>
          </div>
        </div>
      </div>
    </section>
  );
}
